import {
  FormGridItem,
  type FormGridItemProps,
  TextField,
  type TextFieldProps,
  useEmailAddressValidator,
} from '@ace-clublabs/shared-component-library';

import { defaultInputProps, getRequiredFieldSx } from '../utils';

export interface EmailFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<TextFieldProps<'email-address'>>;
  validatorProps?: Parameters<typeof useEmailAddressValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const EmailField: React.FC<EmailFieldProps> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'Email';
  const validator = useEmailAddressValidator({
    label,
    fieldIsRequiredValidationMessage: 'Email is required.',
    patternFailedValidationMessage: 'Email is invalid.',
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={{ xs: 12, lg: 6 }}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <TextField
        for='email-address'
        label={label}
        {...defaultInputProps}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        validator={validator}
        data-testid='email'
        {...fieldProps}
      />
    </FormGridItem>
  );
};
